<template>
  <div class="component-block">
    <div class="spin" v-if="loading">
      <LoadingSpinner />
    </div>
    <NavigationView />
    <div class="block-container">
      <div class="reports-block">
        <div class="reports-top">Отчеты</div>
        <div v-if="!startLoading" class="reports-main">
          <div class="reports-flex">
            <div class="reports-main-left">
              <div class="reports-parameters">
                <ReportsIcon />
                Параметры отчета
              </div>
              <div class="singleselect-label-wrapper">
                <div class="edit-multiselect-label">Выберите шаблон отчета</div>
                <Multiselect
                  v-model="reportTemplate"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="reportTemplates"
                />
              </div>
              <div class="multiselect-label-wrapper">
                <div class="edit-multiselect-label">Перевозчик(и)</div>
                <Multiselect
                  v-model="selectedCarriers"
                  placeholder="*Все перевозчики учетной записи*"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  noResultsText="Результаты не найдены"
                  :options="carriers"
                />
              </div>
              <div v-if="reportTemplate === 'connection' || reportTemplate === 'status'" class="multiselect-label-wrapper">
                <div class="edit-multiselect-label">Выберите ТС</div>
                <Multiselect
                  v-model="selectedObjects"
                  placeholder="*Все ТС выбранных перевозчиков*"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  noResultsText="Результаты не найдены"
                  :options="multiselectItems"
                />
              </div>
              <div
                v-if="reportTemplate === 'orders' || reportTemplate === 'status'"
                class="reports-parameters"
              >
                <PeriodIcon />
                Период выполнения отчета
              </div>
              <div
                v-if="reportTemplate === 'orders' || reportTemplate === 'status'"
                class="datetime-pickers-flex"
              >
                <div class="datetime-picker-wrapper start-time">
                  <VueDatePicker
                    v-model="startTime"
                    :text-input="textInputOptions"
                    :format="format"
                    :teleport="true"
                    position="left"
                    locale="ru"
                    cancel-text="Назад"
                    select-text="Выбрать"
                    :clearable="false"
                  >
                  </VueDatePicker>
                </div>
                <div class="datetime-picker-wrapper">
                  <VueDatePicker
                    v-model="endTime"
                    :text-input="textInputOptions"
                    :format="format"
                    :teleport="true"
                    position="left"
                    locale="ru"
                    cancel-text="Назад"
                    select-text="Выбрать"
                    :clearable="false"
                  >
                  </VueDatePicker>
                </div>
              </div>
              <button @click="createReport" class="button-create">
                Скачать Excel
              </button>
            </div>
            <!--            <div class="reports-main-right">-->
            <!--              <div class="report-wrapper">-->
            <!--                <div class="report-wrapper-init">-->
            <!--                  Для отображения отчета выберите тип отчета, транспортные-->
            <!--                  средства и период формирования отчета в столбце слева-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <LoadingSpinner v-else />
      </div>
    </div>
  </div>
</template>

<script>
import NavigationView from "@/components/NavigationView";
import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import Multiselect from "@vueform/multiselect";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ReportsIcon from "@/components/icons/reports-icon.vue";
import PeriodIcon from "@/components/icons/period-icon.vue";

export default {
  name: "ReportsView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push("/login");
    }
    if (!store.state.user.roles.includes("ROLE_ADMIN")) {
      this.reportTemplate = "connection";
      this.reportTemplates = [
        {
          label: "Отчёт по связи",
          value: "connection",
        },
        {
          label: "Все заявки по каждому перевозчику",
          value: "orders",
        },
        {
          label: "Отчет по отсутствующим ТС",
          value: "missing-trucks",
        },
      ];
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      this.fetchInitialData();
    }
  },
  data() {
    return {
      loading: false,
      startLoading: false,
      reportTemplate: "status",
      reportTemplates: [
        {
          label: "Отчёт по статусам",
          value: "status",
        },
        {
          label: "Отчет по пробегам",
          value: "mileage",
        },
        {
          label: "Отчет по отсутствующим ТС",
          value: "missing-trucks",
        },
        {
          label: "Отчёт по связи",
          value: "connection",
        },
      ],
      selectedCarriers: [],
      carriers: [],
      objects: [],
      selectedObjects: [],
      startTime: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      endTime: new Date(),
      textInputOptions: {
        format: "dd.MM.yyyy HH:mm",
      },
      format: (date) => {
        return date.toLocaleString().replace(",", "").slice(0, -3);
      },
    };
  },
  components: {
    NavigationView,
    LoadingSpinner,
    Multiselect,
    VueDatePicker,
    ReportsIcon,
    PeriodIcon
  },
  methods: {
    async fetchInitialData() {
      try {
        this.startLoading = true;
        const responses = await Promise.all([
          http.get("/api/car/get"),
          http.get("/api/carrier/get/short"),
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.objects = responses[0].data;
        }
        if (responses[1].data !== null && responses[1].status === 200) {
          this.carriers = responses[1].data.carriers;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    async createReport() {
      try {
        this.loading = true;
        var data = {
          carriers: this.selectedCarriers.length === 0 ? this.carriers.map(item => item.value) : this.selectedCarriers,
        };
        if (this.reportTemplate === 'connection' || this.reportTemplate === 'status') {
          data.cars = this.selectedObjects.length === 0 ? this.objects.map(item => item.id) : this.selectedObjects;
        }
        if (this.reportTemplate === 'orders' || this.reportTemplate === 'status') {
          data.start = parseInt(this.startTime.getTime() / 1000);
          data.end = parseInt(this.endTime.getTime() / 1000);
        }
        const response = await http.post(
          `/api/report/${this.reportTemplate}`,
          data,
          {
            responseType: "blob",
          }
        );
        if (response.data !== null) {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          var fileName = response.headers["content-disposition"]
            .split("filename=")[1]
            .split(";")[0]
            .replaceAll(".xlsx", "")
            .replaceAll(".xls", "")
            .replaceAll('"', "");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          toast.success("Отчёт создан успешно!", {
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    multiselectItems() {
      let filtered = this.objects.filter(item => {
        if (this.selectedCarriers.length > 0) {
          if (this.selectedCarriers.includes(item.carrierId)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }).map(item => {
        return {
          value: item.id,
          label: item.gosNumber,
        }
      });

      return filtered;
    }
  },
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}

.reports-block {
  background: #ffffff;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0px 5px 10px #aaacbd;
}

.reports-top {
  padding: 20px;
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
  border-bottom: 1px solid #dde5ed;
}

.reports-main {
  height: calc(100% - 67px);
}

.reports-flex {
  display: flex;
  height: 100%;
}

.reports-main-left {
  background: #dde5ed;
  flex-shrink: 0;
  border-radius: 0 0 0 10px;
  overflow: auto;
  padding: 20px;
  width: 100%;
}

.reports-parameters {
  display: flex;
  align-items: center;
  font-family: OpenSansBold, sans-serif;
  font-size: 16px;
  color: #374957;
  margin-bottom: 20px;
}

.reports-parameters svg {
  margin-right: 10px;
}

.button-create {
  border-radius: 10px;
  color: #ffffff;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: #005291;
  width: 100%;
  height: 38px;
  outline: none;
  border: 0;
  padding: 0 12px;
  cursor: pointer;
  transition: all 0.4s;
}

.button-create:active {
  transform: scale(0.95);
}

.datetime-pickers-flex {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}

.dp__input_icon {
  display: none;
}

/*.datetime-picker-wrapper {*/
/*  width: 100%;*/
/*}*/

.datetime-picker-wrapper.start-time {
  margin-right: 10px;
}

.reports-main-right {
  width: 100%;
  position: relative;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.report-wrapper {
  height: 100%;
  border: 4px dashed #dde5ed;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-wrapper-init {
  font-size: 14px;
  color: #c1c6c8;
  max-width: 490px;
  text-align: center;
}
</style>
